<template>
  <div>
    <div
      v-if="flags.isFetching"
      class="async-loader-screen -helper--flex align-center justify-center"
    >
      <div class="lotti-wrapper">
        <lottie-player
            autoplay
            loop
            mode="normal"
            src="https://lili-mobile-images.s3.amazonaws.com/onboarding/lotti/logo_animation.json"
          ></lottie-player>
      </div>
    </div>
    <div v-if="!flags.isFetching && !isMobile">
      <div class="intro-wrapper">
        <div class="content-side-wrapper">
          <div class="content-side">
            <span class="main-logo-dark-blue "></span>
            <h1 class="intro-title">Banking designed for<br> your business</h1>
            <p class="intro-content">
              Lili empowers your business with the banking features you need, while eliminating the hidden fees you don’t.
            </p>
            <div class="intro-list">
                <p>Apply for an account and build your business with confidence:</p>
                <div class="intro-list-item">
                  <span class="intro-list-icon checkmark-blue"></span>
                  <span class="intro-list-text"><b>4.15%</b> Annual Percentage Yield on savings<sup>1</sup></span>
                </div>
                <div class="intro-list-item">
                  <span class="intro-list-icon checkmark-blue special"></span>
                  <span class="intro-list-text"><b>No hidden fees,</b> no overdraft fees and no minimum deposit<br /> or balance required</span>
                </div>
                <div class="intro-list-item">
                  <span class="intro-list-icon checkmark-blue special"></span>
                  <span class="intro-list-text"><b>Fast money movement,</b> including Express ACH, wire transfers<br />
and expedited check deposits</span>
                </div>
                <div class="intro-list-item">
                  <span class="intro-list-icon checkmark-blue special"></span>
                  <span class="intro-list-text"><b>Run your business finances</b> from one place with built-in<br />
payments, accounting and tax preparation software</span>
                </div>
                <div class="intro-list-item">
                  <span class="intro-list-icon checkmark-blue special"></span>
                  <span class="intro-list-text"><b>Unlock the potential to impact</b> some of your D&B business scores<sup>2</sup></span>
                </div>
            </div>
            <BtnCta
              :is-loading="flags.isLoaderShown"
              txt="Get Started with Lili"
              class="intro-button"
              @click="() => $router.push({ name: 'partner-personal-details' })"
            />
            <!-- <v-btn
                class="main-app-cta active-cta intro-button"
                elevation="0"
                :loading="flags.isLoaderShown"
                id="elCta-partner"
                @click="() => $router.push({ name: 'partner-personal-details' })"
              >
              Get Started with Lili
            </v-btn> -->
            <div class="trust-wrapper">
              <span class="trust-pilot-dark-gray"/>
              <div class="-helper--flex align-center">
                <span class="banner-fdic-dark-gray"/>
                <p class="footer-banner-content">
                  Lili is a financial technology company, not a bank. Banking services provided by Sunrise Banks, N.A., Member FDIC.
                </p>
              </div>
            </div>

          </div>
          <div class="intro-footer">
              <p class="footer-text">
                <sup>1</sup> The Annual Percentage Yield (“APY”) for the Lili Savings Account is variable and may change at any time. The disclosed APY is effective as of September 1, 2023. Must have at least $0.01 in savings to earn interest.
      The APY applies to balances of up to and including $100,000. Any portions of a balance over $100,000 will not earn interest or have a yield. Available to Lili Pro, Lili Smart, and Lili Premium account holders only.
      <br><sup>2</sup> By integrating your Lili Business Bank Account through the D&B Credit Insights banking integration feature, there may be potential for you to positively impact your Delinquency and Failure Scores. Dun & Bradstreet requires a minimum of six months of business banking transaction history to be able to potentially impact these scores.
              </p>
            </div>
        </div>
        <div class="image-side">
          <img src="~@/RF_assets/images/intro.svg" alt="intro-image" class="intro-image" />
          <!-- <div class="intro-image" /> -->
        </div>
      </div>
    </div>
    <div v-if="!flags.isFetching && isMobile">
      <div class="intro-wrapper-mobile">
        <div class="header-content-wrapper">
          <div class="header-content">
            <span class="main-logo-white"></span>
            <div class="header-title">Banking designed for your business</div>
            <div class="header-content-text">
              Lili empowers your business with the banking features you need, while eliminating the hidden fees you don’t.
                        </div>
            <BtnCta
              :is-loading="flags.isLoaderShown"
              :isReverseTheme="true"
              txt="Open an Account"
              class="intro-button"
              @click="() => $router.push({ name: 'partner-personal-details' })"
            />
            <img class="intro-image-mobile" src="../../RF_assets/images/intro-mobile.png" alt="intro-image-mobile" />

          </div>
        </div>
        <div class="inner-wrapper -helper--flex column">
          <div class="trust-wrapper-mobile">
            <span class="trust-pilot-dark-gray"/>
            <div class="-helper--flex align-center">
              <span class="banner-fdic-dark-gray"/>
              <p class="footer-banner-content-mobile">
                Lili is a financial technology company, not a bank. Banking services provided by Sunrise Banks, N.A., Member FDIC.
              </p>
            </div>
          </div>
          <div class="intro-title-mobile">
            Apply for an account and build your business with confidence:
          </div>
        </div>
        <div class="promotion-wrapper-mobile">
          <div class="center-icon-wrapper">
              <span class="center-icon payment-option-icon-black"></span>
            </div>
          <div class="promotion-content-mobile">
            <div class="promotion-text-mobile payment-option">
              No hidden fees, no overdraft fees and no minimum deposit or balance required
            </div>
          </div>
        </div>
        <div class="promotion-wrapper-mobile">
          <div class="center-icon-wrapper">
              <span class="center-icon commision-fees-icon-black"></span>
            </div>
          <div class="promotion-content-mobile">
            <div class="promotion-text-mobile">
              4.15% Annual Percentage Yield on savings*
            </div>
          </div>
        </div>
        <div class="promotion-wrapper-mobile">
          <div class="center-icon-wrapper">
              <span class="center-icon stopper-icon-black"></span>
            </div>
          <div class="promotion-content-mobile">
            <div class="promotion-text-mobile">
              Fast money movement, including Express ACH, wire transfers and expedited
check deposits
            </div>
          </div>
        </div>
        <div class="promotion-wrapper-mobile">
          <div class="center-icon-wrapper">
              <span class="center-icon savings-icon-black"></span>
            </div>
          <div class="promotion-content-mobile">
            <div class="promotion-text-mobile">
              Run your business finances from one place with built-in payments, accounting and
tax preparation software
            </div>
          </div>
        </div>
        <div class="promotion-wrapper-mobile">
          <div class="center-icon-wrapper">
              <span class="center-icon transaction-limit-icon"></span>
            </div>
          <div class="promotion-content-mobile">
            <div class="promotion-text-mobile">
              Unlock the potential to impact some of your D&B business scores
            </div>
          </div>
        </div>
        <div class="mobile-devider"></div>
        <div class="intro-footer-mobile">
          <p class="footer-text-mobile">
            * The Annual Percentage Yield (“APY”) for the Lili Savings Account is variable and may change at any time. The disclosed APY is effective as of September 1, 2023. Must have at least $0.01 in savings to earn interest. The APY applies to balances of up to and including $100,000. Any portions of a balance over $100,000 will not earn interest or have a yield. Available to Lili Pro, Lili Smart, and Lili Premium account holders only.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import * as LottiePlayer from '@lottiefiles/lottie-player'
import {params} from '../../localData'
import {getAdSource} from '../../services/entities/onboardingService'
import tracking from '../../utils/tracking'
import moment from 'moment'
import {dataLayerHandler} from '../../services/analyticsService'
import HTTP from '../../services/HttpService'
import {INSTITUTION_IDS_MAP, BANK_TYPES, ONBOARDING_STATUS, ONBOARDING_TYPE_ENUM} from '../../consts'
import {mapCustomerModelToPrefillData} from '../../services/entities/customerService'
import {handleOnboardingStatus, loginUser} from '../../services/auth'
import {updateCustomerStep} from '../../services/UtilService'
import BtnCta from '../../components/globalUiComponents/btn/BtnCta.vue'

export default {
  name: 'PartnerIntro',
  components: {
    BtnCta
  },
  async beforeMount () {
    this.flags.isFetching = true
    await this.handleInstitution()
    // Start analytics flow
    tracking.startOb(this)
    // Get adSource value from OB service
    this.customer.adSource = getAdSource(this)
    // Update customer state
    this.$store.commit('customer/setKeyValue', { prop: 'adSource', value: this.customer.adSource })
    dataLayerHandler(this, 'start', 'start screen loaded')
    await this.getAndSetPartnerCustomizationData()
  },
  async mounted () {
    this.customer = this.customerData
  },
  data () {
    return {
      customer: {},
      institutionData: {
        id: '',
        linkSrc: '',
        bankType: ''
      },
      flags: {
        isLoaderShown: false,
        isFetching: true
      }
    }
  },
  methods: {
    async handleInstitution () {
      this.flags.isLoaderShown = true
      try {
        this.institutionData = {id: INSTITUTION_IDS_MAP.SUNRISE, bankType: BANK_TYPES.SUNRISE}
        /** Add this param to customer model, so we can use it in last screen */
        this.$store.commit('customer/setKeyValue', {prop: 'institutionData', value: this.institutionData})
        this.flags.isLoaderShown = false
      } catch (e) {
        // TODO Handle error flow @Reem
        this.flags.isLoaderShown = false
      }
    },
    async getAndSetPartnerCustomizationData () {
      const {token} = this.$route.query

      if (!token) return
      this.flags.isFetching = true
      try {
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'partnerToken',
          value: token
        })
        const customerData = await loginUser(token)
        // populate state
        let preFilledData = {
          customerId: customerData.customerId,
          email: customerData.email,
          firstName: customerData.firstName,
          lastName: customerData.lastName,
          phoneNumber: customerData.phoneNumber,
          pro: customerData.pro,
          ssn: customerData.ssn,
          birthDate: customerData.birthDate,
          birthDateNotFormatted: customerData.birthDate ? moment.parseZone(new Date(customerData.birthDate)).format('MM/DD/YYYY') : '',
          ...(customerData.business && {kybData: customerData.business})
        }
        this.formattedPhoneNumber = preFilledData.phoneNumber
        this.formattedSSN = preFilledData.ssn
        if ('customerAddressData' in customerData && Object.keys(customerData.customerAddressData).length) {
        // Address Data
          const addressData = {
            city: customerData.customerAddressData.city,
            line1: customerData.customerAddressData.line1,
            line2: customerData.customerAddressData.line2,
            postalCode: customerData.customerAddressData.postalCode,
            state: customerData.customerAddressData.state
          }
          preFilledData = {...preFilledData, ...addressData}
        }
        if (customerData.email) {
          this.flags.isEmailFieldReady = true
        }
        this.customer.accessToken = customerData.accessToken
        this.customer = {...this.customer, ...preFilledData}
        this.$store.commit('customer/setMultiKeyValues', this.customer)

        const {onboardingStatus, nameTooLong, lastStepData, customerId, accessToken, onboardingTypeEnum} = customerData
        if (onboardingStatus === ONBOARDING_STATUS.DURING_REGISTRATION) {
          updateCustomerStep(this.$store, 0, accessToken, this.customer.customerId)
        }
        try {
          if (lastStepData && lastStepData.step > 0 && accessToken) {
            // for users that completed registration or are in kyb/kyc and edge cases
            if ((onboardingStatus !== ONBOARDING_STATUS.DURING_REGISTRATION && (onboardingTypeEnum === ONBOARDING_TYPE_ENUM.STANDARD || onboardingTypeEnum === null)) ||
              onboardingStatus === ONBOARDING_STATUS.COMPLETED) {
              handleOnboardingStatus(this.$router, this.$store, onboardingStatus, nameTooLong, this.customer, lastStepData, onboardingTypeEnum)
            } else {  // fetch user data for users who didn't complete registration
              if (onboardingStatus === ONBOARDING_STATUS.DURING_REGISTRATION) {
                await this.getAndSetCustomerPreFilledData(customerId, accessToken)
              }

              this.$store.commit('customer/setMultiKeyValues', this.customer)
              handleOnboardingStatus(this.$router, this.$store, onboardingStatus, nameTooLong, this.customer, lastStepData, onboardingTypeEnum)
            }
            return
          } else if (onboardingTypeEnum !== ONBOARDING_TYPE_ENUM.STANDARD && onboardingTypeEnum !== null) { // multi business
            await this.getAndSetCustomerPreFilledData(customerId, accessToken)
            this.$store.commit('customer/setMultiKeyValues', this.customer)
            handleOnboardingStatus(this.$router, this.$store, onboardingStatus, nameTooLong, this.customer, lastStepData, onboardingTypeEnum)
            return
          }
          this.flags.isFetching = false
        } catch (err) {
          if (err.errorCode === '4003') {
            this.$router.push({name: 'partner-personal-details'})
          }
          this.flags.isLoaderShown = false
        }
      } catch (err) {
        this.flags.isFetching = false
      }
    },
    async getAndSetCustomerPreFilledData (customerId, accessToken) {
      const customerDataResults = await HTTP.get(
        `v3/secureonboarding/partner/user/${customerId}`,
        null,
        {
          headerName: params.httpHeaders.auth,
          headerValue: 'lili ' + accessToken
        }
      )

      // merge the pre-filled data with the local customer model
      const mappedData = mapCustomerModelToPrefillData(customerDataResults)
      this.customer = {
        ...this.customer,
        ...mappedData,
        availablePromoCodes: customerDataResults.availablePromoCodes,
        hasSoleProprietor: customerDataResults.hasSoleProprietor
      }
    }
  },
  computed: {
    dynamicDisclaimer () {
      if (this.institutionData.bankType === 'CHOICE') return 'Choice Financial Group'
      if (this.institutionData.bankType === 'SUNRISE') return 'Sunrise Banks, N.A.'
    },
    isLoaderShown () {
      return this.flags.isLoaderShown
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/PartnerIntro.vue